export const FolderSVG = (
  <svg viewBox="0 0 980 855">
    <path
      d="M853.333333 256H469.333333l-85.333333-85.333333H170.666667c-46.933333 0-85.333333 38.4-85.333334 85.333333v170.666667h853.333334v-85.333334c0-46.933333-38.4-85.333333-85.333334-85.333333z"
      fill="#FFA000"
    />
    <path
      d="M853.333333 256H170.666667c-46.933333 0-85.333333 38.4-85.333334 85.333333v426.666667c0 46.933333 38.4 85.333333 85.333334 85.333333h682.666666c46.933333 0 85.333333-38.4 85.333334-85.333333V341.333333c0-46.933333-38.4-85.333333-85.333334-85.333333z"
      fill="#FFCA28"
    />{" "}
  </svg>
);

export const PdfSVG = (
  <svg version="1.1" id="_x35_" viewBox="0 0 512 512">
    <g>
      <polygon
        fill="#B12A27"
        points="475.435,117.825 475.435,512 47.791,512 47.791,0.002 357.613,0.002 412.491,54.881 	"
      />
      <rect
        x="36.565"
        y="34.295"
        fill="#F2F2F2"
        width="205.097"
        height="91.768"
      />
      <g>
        <g>
          <path
            fill="#B12A27"
            d="M110.132,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.658-1.658-3.694-3.015-6.031-3.92
				c-2.412-0.98-5.126-1.432-8.141-1.432H69.651v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432
				c2.337-0.905,4.372-2.261,6.031-3.92c1.659-1.658,2.865-3.543,3.769-5.804c0.829-2.186,1.282-4.523,1.282-6.935
				C111.413,68.902,110.961,66.565,110.132,64.379z M97.844,77.118c-1.508,1.432-3.618,2.186-6.181,2.186H81.034V63.323h10.629
				c2.563,0,4.674,0.754,6.181,2.261c1.432,1.432,2.186,3.392,2.186,5.804C100.031,73.726,99.277,75.686,97.844,77.118z"
          />
          <path
            fill="#B12A27"
            d="M164.558,75.761c-0.075-2.035-0.151-3.844-0.377-5.503c-0.226-1.659-0.603-3.166-1.131-4.598
				c-0.528-1.357-1.206-2.714-2.111-3.92c-2.035-2.94-4.523-5.126-7.312-6.483c-2.865-1.357-6.257-2.035-10.252-2.035h-20.956
				v58.195h20.956c3.995,0,7.387-0.678,10.252-2.035c2.789-1.357,5.277-3.543,7.312-6.483c0.905-1.206,1.583-2.563,2.111-3.92
				c0.528-1.432,0.905-2.94,1.131-4.598c0.226-1.658,0.301-3.468,0.377-5.503c0.075-1.96,0.075-4.146,0.075-6.558
				C164.633,79.908,164.633,77.721,164.558,75.761z M153.175,88.2c0,1.734-0.151,3.091-0.302,4.297
				c-0.151,1.131-0.377,2.186-0.678,2.94c-0.301,0.829-0.754,1.583-1.281,2.261c-1.885,2.412-4.749,3.543-8.518,3.543h-8.669V63.323
				h8.669c3.769,0,6.634,1.206,8.518,3.618c0.528,0.678,0.98,1.357,1.281,2.186s0.528,1.809,0.678,3.015
				c0.151,1.131,0.302,2.563,0.302,4.221c0.075,1.659,0.075,3.694,0.075,5.955C153.251,84.581,153.251,86.541,153.175,88.2z"
          />
          <path
            fill="#B12A27"
            d="M213.18,63.323V53.222h-38.37v58.195h11.383V87.823h22.992V77.646h-22.992V63.323H213.18z"
          />
        </g>
        <g>
          <path
            fill="#B12A27"
            d="M110.132,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.658-1.658-3.694-3.015-6.031-3.92
				c-2.412-0.98-5.126-1.432-8.141-1.432H69.651v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432
				c2.337-0.905,4.372-2.261,6.031-3.92c1.659-1.658,2.865-3.543,3.769-5.804c0.829-2.186,1.282-4.523,1.282-6.935
				C111.413,68.902,110.961,66.565,110.132,64.379z M97.844,77.118c-1.508,1.432-3.618,2.186-6.181,2.186H81.034V63.323h10.629
				c2.563,0,4.674,0.754,6.181,2.261c1.432,1.432,2.186,3.392,2.186,5.804C100.031,73.726,99.277,75.686,97.844,77.118z"
          />
        </g>
      </g>
      <polygon
        opacity="0.08"
        fill="#040000"
        points="475.435,117.825 475.435,512 47.791,512 47.791,419.581 247.705,219.667 
		259.54,207.832 266.098,201.273 277.029,190.343 289.995,177.377 412.491,54.881 	"
      />
      <polygon
        fill="#771B1B"
        points="475.435,117.836 357.599,117.836 357.599,0 	"
      />
      <g>
        <path
          fill="#F2F2F2"
          d="M414.376,370.658c-2.488-4.372-5.88-8.518-10.101-12.287c-3.467-3.166-7.538-6.106-12.137-8.82
			c-18.544-10.93-45.003-16.207-80.961-16.207h-3.618c-1.96-1.809-3.995-3.618-6.106-5.503
			c-13.644-12.287-24.499-25.63-32.942-40.48c16.584-36.561,24.499-69.126,23.519-96.867c-0.151-4.674-0.829-9.046-2.035-13.117
			c-1.809-6.558-4.824-12.363-9.046-17.112c-0.075-0.075-0.075-0.075-0.151-0.151c-6.709-7.538-16.056-11.835-25.555-11.835
			c-9.574,0-18.393,4.146-24.801,11.76c-6.332,7.538-9.724,17.866-9.875,30.002c-0.226,18.544,1.281,36.108,4.448,52.315
			c0.301,1.282,0.528,2.563,0.829,3.844c3.166,14.7,7.84,28.645,13.87,41.611c-7.086,14.398-14.247,26.836-19.223,35.279
			c-3.769,6.408-7.915,13.117-12.212,19.826c-19.373,3.468-35.807,7.689-50.129,12.966c-19.373,7.011-34.902,16.056-46.059,26.836
			c-7.237,6.935-12.137,14.323-14.549,22.012c-2.563,7.915-2.412,15.83,0.452,22.916c2.638,6.558,7.387,12.061,13.72,15.83
			c1.508,0.905,3.091,1.658,4.749,2.337c4.825,1.96,10.101,3.015,15.604,3.015c12.74,0,25.856-5.503,36.937-15.378
			c20.655-18.469,41.988-48.169,54.577-66.94c10.327-1.583,21.559-2.94,34.224-4.297c14.926-1.508,28.118-2.412,40.104-2.865
			c3.694,3.317,7.237,6.483,10.629,9.498c18.846,16.81,33.168,28.947,46.134,37.465c0,0.075,0.075,0.075,0.151,0.075
			c5.126,3.392,10.026,6.181,14.926,8.443c5.503,2.563,11.081,3.92,16.81,3.92c7.237,0,14.021-2.186,19.675-6.181
			c5.729-4.146,9.875-10.101,11.76-16.81C420.18,387.694,418.899,378.724,414.376,370.658z M247.705,219.667
			c-1.055-9.348-1.508-19.072-1.357-29.324c0.151-9.724,3.694-16.283,8.895-16.283c3.92,0,8.066,3.543,9.95,10.327
			c0.528,2.035,0.905,4.372,0.98,7.01c0.151,3.166,0.075,6.483-0.075,9.875c-0.452,9.574-2.111,19.75-4.975,30.681
			c-1.734,7.011-3.995,14.323-6.784,21.936C251.173,243.186,248.911,231.803,247.705,219.667z M121.967,418.073
			c-1.282-3.166,0.151-9.272,7.991-16.81c11.986-11.458,30.756-20.504,56.914-27.364c-4.975,6.784-9.875,12.966-14.624,18.619
			c-7.237,8.744-14.172,16.132-20.429,21.71c-5.352,4.824-11.232,7.84-16.81,8.594c-0.98,0.151-1.96,0.226-2.94,0.226
			C127.168,423.049,123.173,421.089,121.967,418.073z M242.428,337.942l0.528-0.829l-0.829,0.151
			c0.151-0.377,0.377-0.754,0.603-1.055c3.166-5.352,7.161-12.212,11.458-20.127l0.377,0.829l0.98-2.035
			c3.166,4.523,6.634,8.971,10.252,13.267c1.734,2.035,3.543,3.995,5.352,5.955l-1.206,0.075l1.055,0.98
			c-3.091,0.226-6.332,0.528-9.574,0.829c-2.035,0.226-4.146,0.377-6.257,0.603C250.796,337.037,246.499,337.49,242.428,337.942z
			 M369.297,384.98c-8.971-5.729-18.996-13.795-31.359-24.575c17.564,1.809,31.359,5.654,41.159,11.383
			c4.297,2.488,7.538,5.051,9.724,7.538c3.618,3.844,4.9,7.312,4.221,9.649c-0.603,2.337-3.241,3.92-6.483,3.92
			c-1.885,0-3.844-0.452-5.88-1.432c-3.468-1.658-7.086-3.694-10.93-6.181C369.598,385.282,369.448,385.131,369.297,384.98z"
        />
      </g>
    </g>
  </svg>
);

export const VideoSVG = (
  <svg width="85px" height="85px" viewBox="0 0 32 32">
    <title>file_type_video</title>
    <path
      d="M4.5,2.375A2.562,2.562,0,0,1,5.861,2H25.274c.318,0,.635,0,.953,0A2.545,2.545,0,0,1,28.65,3.951a3.37,3.37,0,0,1,.072.862c0,3.725,0,7.451,0,11.176q-.786,0-1.573,0a1.814,1.814,0,0,0-.22.022A5.236,5.236,0,0,0,26.348,16c-.3.007-.61-.014-.914.014a2.275,2.275,0,0,0-.4-.02H20.295c-.2,0-.392.008-.587-.01l.1-.065q-3.177-1.907-6.353-3.813c0,1.3,0,2.593,0,3.889-2.213-.005-4.427,0-6.64,0a2.274,2.274,0,0,0-.251.021C6.352,15.984,6.137,16,5.922,16c-.284.006-.57-.015-.853.015a2.052,2.052,0,0,0-.253-.022q-.771,0-1.541,0c.006-3.635,0-7.27,0-10.9a4.786,4.786,0,0,1,.071-1.131A2.541,2.541,0,0,1,4.5,2.375ZM5.04,4.563a.639.639,0,0,0-.489.606c0,.439,0,.878,0,1.316a.639.639,0,0,0,.627.6c.436,0,.873,0,1.309,0a.638.638,0,0,0,.6-.608c.005-.426,0-.853,0-1.279a.644.644,0,0,0-.329-.575A.708.708,0,0,0,6.4,4.545H5.264A1.081,1.081,0,0,0,5.04,4.563Zm20.341,0a.639.639,0,0,0-.474.607c0,.435,0,.871,0,1.306a.638.638,0,0,0,.6.608c.436.005.872,0,1.308,0a.639.639,0,0,0,.627-.606c.006-.438,0-.876,0-1.314a.638.638,0,0,0-.594-.621c-.348-.009-.7,0-1.045,0A1.98,1.98,0,0,0,25.381,4.567ZM5.042,8.38a.637.637,0,0,0-.452.4,1.078,1.078,0,0,0-.041.386c0,.378,0,.757,0,1.135a.637.637,0,0,0,.6.6c.4.008.795,0,1.192,0a.826.826,0,0,0,.395-.065.641.641,0,0,0,.36-.574c0-.426,0-.853,0-1.279a.638.638,0,0,0-.6-.624c-.338-.008-.677,0-1.016,0A2.385,2.385,0,0,0,5.042,8.38Zm20.338,0a.637.637,0,0,0-.433.4,1.072,1.072,0,0,0-.041.387c0,.377,0,.754,0,1.131a.638.638,0,0,0,.608.607c.406.006.812,0,1.218,0a.739.739,0,0,0,.38-.078.64.64,0,0,0,.335-.558c0-.428,0-.856,0-1.284a.637.637,0,0,0-.593-.622c-.349-.009-.7,0-1.047,0A1.928,1.928,0,0,0,25.379,8.385ZM5.041,12.2a.639.639,0,0,0-.491.608c0,.438-.005.877,0,1.315a.638.638,0,0,0,.627.6c.435,0,.87,0,1.3,0a.638.638,0,0,0,.608-.607c0-.436,0-.871,0-1.307a.638.638,0,0,0-.605-.626c-.348-.007-.7,0-1.045,0A2.12,2.12,0,0,0,5.041,12.2Zm20.335.006a.635.635,0,0,0-.43.394,1.06,1.06,0,0,0-.041.386c0,.377,0,.754,0,1.131a.638.638,0,0,0,.607.608c.435.005.87,0,1.306,0a.639.639,0,0,0,.628-.605c.006-.438,0-.876,0-1.313a.637.637,0,0,0-.592-.622c-.349-.01-.7,0-1.046,0A1.908,1.908,0,0,0,25.377,12.2Z"
      fill="#e75749"
    />
    <path
      d="M13.458,12.1q3.176,1.908,6.353,3.813l-.1.065q-3.127,1.872-6.251,3.748,0-1.868,0-3.736C13.459,14.695,13.456,13.4,13.458,12.1Z"
      fill="#fff"
    />
    <path
      d="M3.275,15.988q.771,0,1.541,0a2.052,2.052,0,0,1,.253.022.645.645,0,0,0-.409.273.883.883,0,0,0-.111.518c0,.348,0,.7,0,1.045a.686.686,0,0,0,.685.689q.6,0,1.192,0a.68.68,0,0,0,.657-.569c.008-.447,0-.9,0-1.343a.632.632,0,0,0-.521-.613,2.274,2.274,0,0,1,.251-.021c2.213,0,4.427,0,6.64,0q0,1.868,0,3.736,3.127-1.871,6.251-3.748c.2.018.391.007.587.01h4.741a2.275,2.275,0,0,1,.4.02.637.637,0,0,0-.475.385.983.983,0,0,0-.045.407c0,.338,0,.676,0,1.014a.677.677,0,0,0,.691.719q.58,0,1.16,0a.684.684,0,0,0,.686-.658c0-.328,0-.656,0-.984a1.074,1.074,0,0,0-.1-.589.642.642,0,0,0-.42-.292,1.814,1.814,0,0,1,.22-.022q.786,0,1.573,0c.011,1.721,0,3.443,0,5.165q0,3.147,0,6.293a2.567,2.567,0,0,1-.612,1.651,2.539,2.539,0,0,1-1.563.868,7.534,7.534,0,0,1-.981.033H6.724a9.27,9.27,0,0,1-1.368-.048,2.557,2.557,0,0,1-2-1.846,2.825,2.825,0,0,1-.09-.746q0-5.233,0-10.466C3.273,16.591,3.264,16.289,3.275,15.988ZM5.07,19.831a.613.613,0,0,0-.386.234.761.761,0,0,0-.134.464c0,.387,0,.775,0,1.162a.685.685,0,0,0,.686.658c.428,0,.855,0,1.283,0a.687.687,0,0,0,.568-.716c0-.4,0-.794,0-1.191a.617.617,0,0,0-.2-.458.712.712,0,0,0-.487-.17H5.264A1.039,1.039,0,0,0,5.07,19.831Zm20.366,0a.62.62,0,0,0-.522.58c0,.407,0,.815,0,1.222a.676.676,0,0,0,.69.718c.428,0,.857.005,1.285,0a.7.7,0,0,0,.562-.684q0-.507,0-1.013a.9.9,0,0,0-.123-.568.661.661,0,0,0-.532-.267c-.318,0-.636,0-.954,0A2.246,2.246,0,0,0,25.436,19.83ZM5.071,23.648a.609.609,0,0,0-.4.249.766.766,0,0,0-.124.448c0,.378,0,.755,0,1.132a.7.7,0,0,0,.6.688c.459,0,.917,0,1.376,0a.687.687,0,0,0,.567-.717c0-.4,0-.792,0-1.189a.617.617,0,0,0-.2-.459.71.71,0,0,0-.484-.17H5.265A1.028,1.028,0,0,0,5.071,23.648Zm20.362,0a.616.616,0,0,0-.492.427.99.99,0,0,0-.029.33c0,.4,0,.8,0,1.195a.681.681,0,0,0,.656.567h1.193a.689.689,0,0,0,.686-.719c0-.388,0-.776,0-1.164a.657.657,0,0,0-.286-.545,1.461,1.461,0,0,0-.787-.11C26.062,23.639,25.745,23.609,25.434,23.647Z"
      fill="#c0392b"
    />
  </svg>
);

export const AccessSVG = (
  <svg width="85px" height="85px" viewBox="0 0 32 32">
    <defs>
      <linearGradient
        id="a"
        x1="4.416"
        y1="-1909.341"
        x2="13.909"
        y2="-1892.9"
        gradientTransform="translate(0 1917.121)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#b72c3f" />
        <stop offset="0.5" stopColor="#b12334" />
        <stop offset="1" stopColor="#9d1623" />
      </linearGradient>
    </defs>
    <title>file_type_access</title>
    <path
      d="M8.512,20v6.667c0,1.84,4.81,3.333,10.744,3.333S30,28.507,30,26.667V20Z"
      fill="#881421"
    />
    <path
      d="M8.512,12.667V20c0,1.841,4.81,3.333,10.744,3.333S30,21.841,30,20V12.667Z"
      fill="#af2031"
    />
    <path
      d="M8.512,5.333v7.334c0,1.84,4.81,3.333,10.744,3.333S30,14.507,30,12.667V5.333Z"
      fill="#c94f60"
    />
    <ellipse cx="19.256" cy="5.333" rx="10.744" ry="3.333" fill="#e08095" />
    <path
      d="M16.434,8H8.512V24.667h7.922a1.212,1.212,0,0,0,1.194-1.222V9.222A1.212,1.212,0,0,0,16.434,8Z"
      opacity="0.10000000149011612"
      isolation="isolate"
    />
    <path
      d="M15.783,8.667H8.512V25.333h7.271a1.212,1.212,0,0,0,1.194-1.222V9.889A1.212,1.212,0,0,0,15.783,8.667Z"
      opacity="0.20000000298023224"
      isolation="isolate"
    />
    <path
      d="M15.783,8.667H8.512V24h7.271a1.212,1.212,0,0,0,1.194-1.222V9.889A1.212,1.212,0,0,0,15.783,8.667Z"
      opacity="0.20000000298023224"
      isolation="isolate"
    />
    <path
      d="M15.132,8.667H8.512V24h6.62a1.213,1.213,0,0,0,1.194-1.222V9.889A1.213,1.213,0,0,0,15.132,8.667Z"
      opacity="0.20000000298023224"
      isolation="isolate"
    />
    <path
      d="M3.194,8.667H15.132a1.208,1.208,0,0,1,1.194,1.222V22.111a1.208,1.208,0,0,1-1.194,1.222H3.194A1.208,1.208,0,0,1,2,22.111V9.889A1.208,1.208,0,0,1,3.194,8.667Z"
      fill="url(#a)"
    />
    <path
      d="M8.305,12.027h1.758l2.825,7.945h-1.66l-.623-1.895H7.7l-.611,1.895H5.437Zm1.926,4.826-.9-2.875a3.812,3.812,0,0,1-.165-.649H9.13A3.729,3.729,0,0,1,8.968,14l-.912,2.859Z"
      fill="#fff"
    />
  </svg>
);

export const CssSVG = (
  <svg width="85px" height="85px" viewBox="0 0 32 32">
    <title>file_type_cssmap</title>
    <path
      d="M16,30A14,14,0,1,1,30,16,14.016,14.016,0,0,1,16,30ZM16,3.176A12.824,12.824,0,1,0,28.824,16,12.84,12.84,0,0,0,16,3.176Z"
      fill="#33a9dc"
    />
    <rect x="2.784" y="15.412" width="26.432" height="1.176" fill="#33a9dc" />
    <path
      d="M16.317,10.474A44.779,44.779,0,0,1,4.42,8.92l.34-1.126c.111.034,11.277,3.32,22.427,0l.335,1.127A39.374,39.374,0,0,1,16.317,10.474Z"
      fill="#33a9dc"
    />
    <path
      d="M4.785,23.907,4.45,22.781c11.5-3.422,22.634-.14,23.1,0l-.34,1.126C27.1,23.873,15.936,20.588,4.785,23.907Z"
      fill="#33a9dc"
    />
    <path
      d="M11.468,28.764a35.454,35.454,0,0,1-.742-25.71l1.082.461A34.228,34.228,0,0,0,12.55,28.3Z"
      fill="#33a9dc"
    />
    <path
      d="M20.441,28.764,19.36,28.3A34.229,34.229,0,0,0,20.1,3.515l1.082-.461A35.461,35.461,0,0,1,20.441,28.764Z"
      fill="#33a9dc"
    />
    <rect x="15.412" y="2.783" width="1.175" height="26.919" fill="#33a9dc" />
    <polygon
      points="14.127 28.901 12.442 10 30.958 10 29.272 28.898 21.689 31 14.127 28.901"
      fill="#1572b6"
    />
    <polygon
      points="21.7 29.393 27.827 27.694 29.269 11.545 21.7 11.545 21.7 29.393"
      fill="#33a9dc"
    />
    <polygon
      points="21.7 18.393 24.768 18.393 24.979 16.019 21.7 16.019 21.7 13.701 21.708 13.701 27.513 13.701 27.457 14.323 26.887 20.711 21.7 20.711 21.7 18.393"
      fill="#fff"
    />
    <polygon
      points="21.714 24.413 21.704 24.416 19.122 23.719 18.957 21.87 17.703 21.87 16.63 21.87 16.955 25.51 21.703 26.828 21.714 26.825 21.714 24.413"
      fill="#ebebeb"
    />
    <polygon
      points="24.57 20.613 24.291 23.718 21.706 24.415 21.706 26.827 26.458 25.51 26.493 25.118 26.896 20.613 24.57 20.613"
      fill="#fff"
    />
    <polygon
      points="21.708 13.701 21.708 15.141 21.708 16.014 21.708 16.019 16.116 16.019 16.116 16.019 16.109 16.019 16.062 15.498 15.957 14.323 15.901 13.701 21.708 13.701"
      fill="#ebebeb"
    />
    <polygon
      points="21.7 18.393 21.7 19.833 21.7 20.706 21.7 20.712 19.158 20.712 19.158 20.712 19.151 20.712 19.105 20.191 18.999 19.015 18.944 18.393 21.7 18.393"
      fill="#ebebeb"
    />
  </svg>
);

export const UnknownSVG = (
  <svg width="85px" height="85px" viewBox="0 0 32 32">
    <title>default_file</title>
    <path d="M20.414,2H5V30H27V8.586ZM7,28V4H19v6h6V28Z" fill="#c5c5c5" />
  </svg>
);

export const SqlSVG = (
  <svg fill="#000000" width="85px" height="85px" viewBox="0 0 32 32">
    <title>file_type_plsql</title>
    <path
      d="M8.562,15.256A21.159,21.159,0,0,0,16,16.449a21.159,21.159,0,0,0,7.438-1.194c1.864-.727,2.525-1.535,2.525-2V9.7a10.357,10.357,0,0,1-2.084,1.076A22.293,22.293,0,0,1,16,12.078a22.36,22.36,0,0,1-7.879-1.3A10.28,10.28,0,0,1,6.037,9.7v3.55C6.037,13.724,6.7,14.528,8.562,15.256Z"
      fill="red"
    />
    <path
      d="M8.562,21.961a15.611,15.611,0,0,0,2.6.741A24.9,24.9,0,0,0,16,23.155a24.9,24.9,0,0,0,4.838-.452,15.614,15.614,0,0,0,2.6-.741c1.864-.727,2.525-1.535,2.525-2v-3.39a10.706,10.706,0,0,1-1.692.825A23.49,23.49,0,0,1,16,18.74a23.49,23.49,0,0,1-8.271-1.348,10.829,10.829,0,0,1-1.692-.825V19.96C6.037,20.426,6.7,21.231,8.562,21.961Z"
      fill="red"
    />
    <path
      d="M16,30c5.5,0,9.963-1.744,9.963-3.894V23.269a10.5,10.5,0,0,1-1.535.762l-.157.063A23.487,23.487,0,0,1,16,25.445a23.422,23.422,0,0,1-8.271-1.351c-.054-.02-.106-.043-.157-.063a10.5,10.5,0,0,1-1.535-.762v2.837C6.037,28.256,10.5,30,16,30Z"
      fill="red"
    />
    <ellipse cx="16" cy="5.894" rx="9.963" ry="3.894" fill="red" />
  </svg>
);

export const ExcelSVG = (
  <svg width="85px" height="85px" viewBox="0 0 32 32">
    <defs>
      <linearGradient
        id="a"
        x1="4.494"
        y1="-2092.086"
        x2="13.832"
        y2="-2075.914"
        gradientTransform="translate(0 2100)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#18884f" />
        <stop offset="0.5" stopColor="#117e43" />
        <stop offset="1" stopColor="#0b6631" />
      </linearGradient>
    </defs>
    <title>file_type_excel</title>
    <path
      d="M19.581,15.35,8.512,13.4V27.809A1.192,1.192,0,0,0,9.705,29h19.1A1.192,1.192,0,0,0,30,27.809h0V22.5Z"
      fill="#185c37"
    />
    <path
      d="M19.581,3H9.705A1.192,1.192,0,0,0,8.512,4.191h0V9.5L19.581,16l5.861,1.95L30,16V9.5Z"
      fill="#21a366"
    />
    <path d="M8.512,9.5H19.581V16H8.512Z" fill="#107c41" />
    <path
      d="M16.434,8.2H8.512V24.45h7.922a1.2,1.2,0,0,0,1.194-1.191V9.391A1.2,1.2,0,0,0,16.434,8.2Z"
      opacity="0.10000000149011612"
      isolation="isolate"
    />
    <path
      d="M15.783,8.85H8.512V25.1h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
      opacity="0.20000000298023224"
      isolation="isolate"
    />
    <path
      d="M15.783,8.85H8.512V23.8h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
      opacity="0.20000000298023224"
      isolation="isolate"
    />
    <path
      d="M15.132,8.85H8.512V23.8h6.62a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.132,8.85Z"
      opacity="0.20000000298023224"
      isolation="isolate"
    />
    <path
      d="M3.194,8.85H15.132a1.193,1.193,0,0,1,1.194,1.191V21.959a1.193,1.193,0,0,1-1.194,1.191H3.194A1.192,1.192,0,0,1,2,21.959V10.041A1.192,1.192,0,0,1,3.194,8.85Z"
      fill="url(#a)"
    />
    <path
      d="M5.7,19.873l2.511-3.884-2.3-3.862H7.758L9.013,14.6c.116.234.2.408.238.524h.017c.082-.188.169-.369.26-.546l1.342-2.447h1.7l-2.359,3.84,2.419,3.905H10.821l-1.45-2.711A2.355,2.355,0,0,1,9.2,16.8H9.176a1.688,1.688,0,0,1-.168.351L7.515,19.873Z"
      fill="#fff"
    />
    <path
      d="M28.806,3H19.581V9.5H30V4.191A1.192,1.192,0,0,0,28.806,3Z"
      fill="#33c481"
    />
    <path d="M19.581,16H30v6.5H19.581Z" fill="#107c41" />
  </svg>
);

export const PptSVG = (
  <svg width="85px" height="85px" viewBox="0 0 32 32">
    <defs>
      <linearGradient
        id="a"
        x1="4.494"
        y1="-1748.086"
        x2="13.832"
        y2="-1731.914"
        gradientTransform="translate(0 1756)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#ca4c28" />
        <stop offset="0.5" stopColor="#c5401e" />
        <stop offset="1" stopColor="#b62f14" />
      </linearGradient>
    </defs>
    <title>file_type_powerpoint</title>
    <path
      d="M18.93,17.3,16.977,3h-.146A12.9,12.9,0,0,0,3.953,15.854V16Z"
      fill="#ed6c47"
    />
    <path
      d="M17.123,3h-.146V16l6.511,2.6L30,16v-.146A12.9,12.9,0,0,0,17.123,3Z"
      fill="#ff8f6b"
    />
    <path
      d="M30,16v.143A12.905,12.905,0,0,1,17.12,29h-.287A12.907,12.907,0,0,1,3.953,16.143V16Z"
      fill="#d35230"
    />
    <path
      d="M17.628,9.389V23.26a1.2,1.2,0,0,1-.742,1.1,1.16,1.16,0,0,1-.45.091H7.027c-.182-.208-.358-.429-.521-.65a12.735,12.735,0,0,1-2.553-7.657v-.286A12.705,12.705,0,0,1,6.05,8.85c.143-.221.293-.442.456-.65h9.93A1.2,1.2,0,0,1,17.628,9.389Z"
      opacity="0.10000000149011612"
      isolation="isolate"
    />
    <path
      d="M16.977,10.04V23.911a1.15,1.15,0,0,1-.091.448,1.2,1.2,0,0,1-1.1.741H7.62q-.309-.314-.593-.65c-.182-.208-.358-.429-.521-.65a12.735,12.735,0,0,1-2.553-7.657v-.286A12.705,12.705,0,0,1,6.05,8.85h9.735A1.2,1.2,0,0,1,16.977,10.04Z"
      opacity="0.20000000298023224"
      isolation="isolate"
    />
    <path
      d="M16.977,10.04V22.611A1.2,1.2,0,0,1,15.785,23.8H6.506a12.735,12.735,0,0,1-2.553-7.657v-.286A12.705,12.705,0,0,1,6.05,8.85h9.735A1.2,1.2,0,0,1,16.977,10.04Z"
      opacity="0.20000000298023224"
      isolation="isolate"
    />
    <path
      d="M16.326,10.04V22.611A1.2,1.2,0,0,1,15.134,23.8H6.506a12.735,12.735,0,0,1-2.553-7.657v-.286A12.705,12.705,0,0,1,6.05,8.85h9.084A1.2,1.2,0,0,1,16.326,10.04Z"
      opacity="0.20000000298023224"
      isolation="isolate"
    />
    <path
      d="M3.194,8.85H15.132a1.193,1.193,0,0,1,1.194,1.191V21.959a1.193,1.193,0,0,1-1.194,1.191H3.194A1.192,1.192,0,0,1,2,21.959V10.041A1.192,1.192,0,0,1,3.194,8.85Z"
      fill="url(#a)"
    />
    <path
      d="M9.293,12.028a3.287,3.287,0,0,1,2.174.636,2.27,2.27,0,0,1,.756,1.841,2.555,2.555,0,0,1-.373,1.376,2.49,2.49,0,0,1-1.059.935A3.607,3.607,0,0,1,9.2,17.15H7.687v2.8H6.141V12.028ZM7.686,15.94H9.017a1.735,1.735,0,0,0,1.177-.351,1.3,1.3,0,0,0,.4-1.025q0-1.309-1.525-1.31H7.686V15.94Z"
      fill="#fff"
    />
  </svg>
);

export const HtmlSVG = (
  <svg width="85px" height="85px" viewBox="0 0 32 32">
    <title>file_type_html</title>
    <polygon
      points="5.902 27.201 3.655 2 28.345 2 26.095 27.197 15.985 30 5.902 27.201"
      fill="#e44f26"
    />
    <polygon
      points="16 27.858 24.17 25.593 26.092 4.061 16 4.061 16 27.858"
      fill="#f1662a"
    />
    <polygon
      points="16 13.407 11.91 13.407 11.628 10.242 16 10.242 16 7.151 15.989 7.151 8.25 7.151 8.324 7.981 9.083 16.498 16 16.498 16 13.407"
      fill="#ebebeb"
    />
    <polygon
      points="16 21.434 15.986 21.438 12.544 20.509 12.324 18.044 10.651 18.044 9.221 18.044 9.654 22.896 15.986 24.654 16 24.65 16 21.434"
      fill="#ebebeb"
    />
    <polygon
      points="15.989 13.407 15.989 16.498 19.795 16.498 19.437 20.507 15.989 21.437 15.989 24.653 22.326 22.896 22.372 22.374 23.098 14.237 23.174 13.407 22.341 13.407 15.989 13.407"
      fill="#fff"
    />
    <polygon
      points="15.989 7.151 15.989 9.071 15.989 10.235 15.989 10.242 23.445 10.242 23.445 10.242 23.455 10.242 23.517 9.548 23.658 7.981 23.732 7.151 15.989 7.151"
      fill="#fff"
    />
  </svg>
);

export const JsSVG = (
  <svg width="85px" height="85px" viewBox="0 0 32 32">
    <title>file_type_js_official</title>
    <rect x="2" y="2" width="28" height="28" fill="#f5de19" />
    <path d="M20.809,23.875a2.866,2.866,0,0,0,2.6,1.6c1.09,0,1.787-.545,1.787-1.3,0-.9-.716-1.222-1.916-1.747l-.658-.282c-1.9-.809-3.16-1.822-3.16-3.964,0-1.973,1.5-3.476,3.853-3.476a3.889,3.889,0,0,1,3.742,2.107L25,18.128A1.789,1.789,0,0,0,23.311,17a1.145,1.145,0,0,0-1.259,1.128c0,.789.489,1.109,1.618,1.6l.658.282c2.236.959,3.5,1.936,3.5,4.133,0,2.369-1.861,3.667-4.36,3.667a5.055,5.055,0,0,1-4.795-2.691Zm-9.295.228c.413.733.789,1.353,1.693,1.353.864,0,1.41-.338,1.41-1.653V14.856h2.631v8.982c0,2.724-1.6,3.964-3.929,3.964a4.085,4.085,0,0,1-3.947-2.4Z" />
  </svg>
);

export const WordSVG = (
  <svg width="85px" height="85px" viewBox="0 0 32 32">
    <defs>
      <linearGradient
        id="a"
        x1="4.494"
        y1="-1712.086"
        x2="13.832"
        y2="-1695.914"
        gradientTransform="translate(0 1720)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#2368c4" />
        <stop offset="0.5" stopColor="#1a5dbe" />
        <stop offset="1" stopColor="#1146ac" />
      </linearGradient>
    </defs>
    <title>file_type_word</title>
    <path
      d="M28.806,3H9.705A1.192,1.192,0,0,0,8.512,4.191h0V9.5l11.069,3.25L30,9.5V4.191A1.192,1.192,0,0,0,28.806,3Z"
      fill="#41a5ee"
    />
    <path d="M30,9.5H8.512V16l11.069,1.95L30,16Z" fill="#2b7cd3" />
    <path d="M8.512,16v6.5L18.93,23.8,30,22.5V16Z" fill="#185abd" />
    <path
      d="M9.705,29h19.1A1.192,1.192,0,0,0,30,27.809h0V22.5H8.512v5.309A1.192,1.192,0,0,0,9.705,29Z"
      fill="#103f91"
    />
    <path
      d="M16.434,8.2H8.512V24.45h7.922a1.2,1.2,0,0,0,1.194-1.191V9.391A1.2,1.2,0,0,0,16.434,8.2Z"
      opacity="0.10000000149011612"
      isolation="isolate"
    />
    <path
      d="M15.783,8.85H8.512V25.1h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
      opacity="0.20000000298023224"
      isolation="isolate"
    />
    <path
      d="M15.783,8.85H8.512V23.8h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
      opacity="0.20000000298023224"
      isolation="isolate"
    />
    <path
      d="M15.132,8.85H8.512V23.8h6.62a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.132,8.85Z"
      opacity="0.20000000298023224"
      isolation="isolate"
    />
    <path
      d="M3.194,8.85H15.132a1.193,1.193,0,0,1,1.194,1.191V21.959a1.193,1.193,0,0,1-1.194,1.191H3.194A1.192,1.192,0,0,1,2,21.959V10.041A1.192,1.192,0,0,1,3.194,8.85Z"
      fill="url(#a)"
    />
    <path
      d="M6.9,17.988c.023.184.039.344.046.481h.028c.01-.13.032-.287.065-.47s.062-.338.089-.465l1.255-5.407h1.624l1.3,5.326a7.761,7.761,0,0,1,.162,1h.022a7.6,7.6,0,0,1,.135-.975l1.039-5.358h1.477l-1.824,7.748H10.591L9.354,14.742q-.054-.222-.122-.578t-.084-.52H9.127q-.021.189-.084.561c-.042.249-.075.432-.1.552L7.78,19.871H6.024L4.19,12.127h1.5l1.131,5.418A4.469,4.469,0,0,1,6.9,17.988Z"
      fill="#fff"
    />
  </svg>
);

export const TextSVG = (
  <svg width="85px" height="85px" viewBox="0 0 32 32">
    <title>file_type_text</title>
    <path
      d="M22.038,2H6.375a1.755,1.755,0,0,0-1.75,1.75v24.5A1.755,1.755,0,0,0,6.375,30h19.25a1.755,1.755,0,0,0,1.75-1.75V6.856Zm.525,2.844,1.663,1.531H22.563ZM6.375,28.25V3.75H20.813V8.125h4.813V28.25Z"
      fill="#c2c2c2"
    />
    <rect x="8.125" y="15.097" width="13.076" height="1.75" fill="#829ec2" />
    <rect x="8.125" y="24.439" width="9.762" height="1.75" fill="#829ec2" />
    <rect x="8.125" y="19.763" width="15.75" height="1.75" fill="#829ec2" />
    <rect x="8.125" y="10.23" width="15.75" height="1.75" fill="#829ec2" />
  </svg>
);
